export const validateInn = async (inn: string): Promise<boolean> => {
  try {
    const response = await fetch(
      "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Token 0dd6a3dd8d4da6fbae10577b28c3c35fee8dc692",
        },
        body: JSON.stringify({ query: inn }),
      }
    );

    if (!response.ok) {
      console.error("Ошибка при запросе к DaData API:", response.status);
      return false;
    }

    const data = await response.json();
    return data.suggestions && data.suggestions.length > 0;
  } catch (error) {
    console.error("Ошибка при проверке ИНН:", error);
    return false;
  }
};
